import React from "react";
import { connect } from 'react-redux';
import CheckOutCard from "./components/Card";
import CheckOutPayment from "./components/Payment";

const Checkout = (props) => {
    return (
        <div className="checkoutContainer">
            {props.step === 1 ? <CheckOutCard/> : <CheckOutPayment/>}
        </div>
    );
};

const mapStateToProps = (state) => {
    const { step } = state.payments;
    return { step };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);